import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

export const NotFound: React.FC = () => {
  return (
    <div className="bg-slate-50 min-h-screen flex flex-col items-center justify-center text-center px-6">
      <div className="bg-white p-12 border border-slate-200 shadow-xl max-w-lg w-full relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2 bg-brand-red"></div>
        <AlertTriangle size={64} className="text-brand-red mx-auto mb-6" />
        <h1 className="text-6xl font-display font-bold text-slate-900 mb-2">404</h1>
        <h2 className="text-xl font-mono uppercase tracking-widest text-slate-500 mb-8">Page introuvable</h2>
        <p className="text-slate-600 mb-8">
          La page que vous recherchez semble avoir été déplacée ou n'existe pas.
        </p>
        <Link to="/" className="inline-block bg-slate-900 text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-brand-red transition-colors">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};